module.exports = __webpack_public_path__ + "static/media/temperature-frigid.fcf1af68.svg";